import User from './models/User'

let userModel = new User();

export default {

  namespaced: true,

  state: {
    user: userModel
  },

  mutations: {
    ...userModel.commonMutations()
  },

  actions: {

  },

  getters: {

  }

}